import { AsyncPipe, CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
  MatAutocomplete,
  MatAutocompleteDefaultOptions,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { ErrorStateMatcher, MAT_RIPPLE_GLOBAL_OPTIONS, MatOption, RippleGlobalOptions } from '@angular/material/core';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatError,
  MatFormField,
  MatHint,
  MatLabel,
  MatPrefix,
  MatSuffix,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
  DynamicFormControlCustomEvent,
  DynamicFormControlLayout,
  DynamicFormLayout,
  DynamicFormLayoutService,
  DynamicFormValidationService,
  DynamicInputModel,
} from '@ng-dynamic-forms/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { DynamicMaterialFormInputControlComponent } from '../dynamic-material-form-input-control.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@Component({
  selector: 'dynamic-material-input',
  templateUrl: './dynamic-material-input.component.html',
  imports: [
    CommonModule,
    MatFormField,
    ReactiveFormsModule,
    NgClass,
    MatLabel,
    MatPrefix,
    MatInput,
    MatAutocompleteTrigger,
    MatSuffix,
    MatHint,
    MatError,
    MatAutocomplete,
    MatOption,
    AsyncPipe,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [provideNgxMask()],
})
export class DynamicMaterialInputComponent extends DynamicMaterialFormInputControlComponent implements OnInit {
  @Input() formLayout: DynamicFormLayout;
  @Input() group: FormGroup;
  @Input() layout: DynamicFormControlLayout;
  @Input() model: DynamicInputModel;

  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();

  @ViewChild('matAutocomplete', { static: true }) matAutocomplete: MatAutocomplete;
  @ViewChild(MatInput, { static: true }) matInput: MatInput;

  inputHasValue = false;
  isFocus = false;

  get activeCountry$(): Observable<string> {
    return this.countryService.getActive().pipe(map((country) => country.toUpperCase()));
  }

  get mobilePrefix$(): Observable<string> {
    return this.componentService.mobilePrefixInput$;
  }

  get mobilePrefix() {
    const mobilePrefix =
      this.storageService.getLocalStorageItem('mobilePrefix') !== 'undefined'
        ? this.storageService.getLocalStorageItem('mobilePrefix')
        : '';
    return mobilePrefix;
  }

  checkInput(input: any) {
    this.inputHasValue = input ? true : false;
  }

  ifFocus(event: string) {
    this.isFocus = event ? true : false;
  }

  removeHTMLTags(value: any) {
    const hasRequested = this.storageService.getLocalStorageItem('hasRequested');
    if (hasRequested !== 'true') {
      if (value !== null && typeof value !== 'undefined') {
        return value.toString().replace(/<[^>]*>/g, '');
      } else {
        return '';
      }
    } else {
      return value;
    }
  }

  checkPrefixId(modelId: any) {
    let prefixId;
    if (modelId === 'phoneNumber' || modelId === 'faxNumber' || modelId === 'contactNumber') {
      prefixId = modelId;
    }
    return prefixId;
  }

  constructor(
    protected layoutService: DynamicFormLayoutService,
    protected validationService: DynamicFormValidationService,
    protected componentService: ComponentService,
    protected countryService: ShimanoCountryService,
    private storageService: StorageService,
    @Inject(ErrorStateMatcher) public errorStateMatcher: ErrorStateMatcher,
    @Inject(MAT_AUTOCOMPLETE_DEFAULT_OPTIONS) public AUTOCOMPLETE_OPTIONS: MatAutocompleteDefaultOptions,
    @Inject(MAT_FORM_FIELD_DEFAULT_OPTIONS) @Optional() public LABEL_OPTIONS: any,
    @Inject(MAT_RIPPLE_GLOBAL_OPTIONS) @Optional() public RIPPLE_OPTIONS: RippleGlobalOptions
  ) {
    super(layoutService, validationService);
  }

  ngOnInit(): void {
    this.removeHTMLTags(this.model);
  }
}
